import { Component, computed, input } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { XwaiModelVizComponent } from "./xwai-model-viz/xwai-model-viz.component";
import { XwaiShotVizComponent } from "./xwai-shot-viz/xwai-shot-viz.component";
import { AgentViz } from "./xwai-viz.types";

export { AgentViz, VizParams, ShotVizParams } from "./xwai-viz.types";

/**
 * Dispatcher for an agent visualization. Switches on `viz.type` and delegates to
 * the matching child renderer (model / shot); unknown types fall back to the raw
 * payload so nothing is silently dropped.
 */
@Component({
  selector: "app-xwai-viz",
  templateUrl: "./xwai-viz.component.html",
  styleUrls: ["./xwai-viz.component.less"],
  imports: [SharedModule, XwaiModelVizComponent, XwaiShotVizComponent],
})
export class XwaiVizComponent {
  readonly viz = input.required<AgentViz>();

  readonly type = computed(() => this.viz().type ?? "unknown");

  /** Raw input, for the unknown-type fallback. */
  readonly raw = computed(() => this.viz());
}
